import React, { useEffect, useState } from 'react'
import { CookieProvider } from './CookieProvider'
import CookieConsentBanner from 'components/cookiebanner/CookieBanner'
import { LinkProvider } from './LinkContext'
import { ModalStateProvider } from './ModalStateContext'
import { JobylonProvider } from './JobylonListContext'
import { BackendProvider } from './BackendContext'
import Script from 'next/script'
import { ApolloProvider } from '@apollo/client/react/context/ApolloProvider'
import { getApolloClient, getDummyApolloClient } from 'utils/apollo-client'

const AppProviders = ({
  children,
  jobs,
  navHeaders,
  topBanners,
  footerData,
  initialProductInfo,
  initialPaymentOptions,
  initialChristmasDeliveryDates,
}) => {
  const [client, setClient] = useState(() => getDummyApolloClient())
  useEffect(() => {
    const initializeClient = async () => {
      const apolloClient = await getApolloClient()
      setClient(apolloClient)
    }

    initializeClient()
  }, [])

  return (
    <ApolloProvider client={client}>
      <CookieProvider>
        <CookieConsentBanner />
        <LinkProvider>
          <ModalStateProvider>
            <JobylonProvider jobylonlist={jobs}>
              <BackendProvider
                navHeaders={navHeaders}
                topBanners={topBanners}
                footerData={footerData}
                initialProductInfo={initialProductInfo}
                initialPaymentOptions={initialPaymentOptions}
                initialChristmasDeliveryDates={initialChristmasDeliveryDates}
              >
                {children}
              </BackendProvider>
            </JobylonProvider>
          </ModalStateProvider>
        </LinkProvider>
        <Script src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" strategy="lazyOnload" />
      </CookieProvider>
    </ApolloProvider>
  )
}

export default AppProviders
